/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice\src\Utils\common.utils.ts
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyBuy\mobybuy_frontoffice
 * Created Date: Friday September 6th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday September 6th 2024 3:21:13 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

export const formatSiren = (value: string) => {
    const cleanedValue = value.replace(/\s+/g, '');
    const part1 = cleanedValue.slice(0, 9).replace(/(\d{3})(?=\d)/g, '$1 ').trim();
    return `${part1}`.trim();
};
